import React from "react";
import "./Project.scss";
import { useParams, Navigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Slider from "../components/Slider";

const BASE_URL = "https://laurephilippe.fr";

const Project = ({
  projects = [],
  activeInfoIds,
  setActiveInfoIds,
  setShowInfo,
}) => {
  const { projectUrl } = useParams();
  const location = useLocation();

  // Find project based on url parameter
  const project = projects.find((p) => p.fields?.url === projectUrl);

  if (projects.length > 0 && !project) {
    return <Navigate to="/" replace />;
  }

  if (!project) return null;

  return (
    <div className="project-page">
      <Helmet>
        <title>{`${project.fields?.titre} - Laure Philippe`}</title>
        <link rel="canonical" href={`${BASE_URL}${location.pathname}`} />
      </Helmet>
      <Slider
        photos={project.fields?.photos || []}
        activeInfoIds={activeInfoIds}
        setActiveInfoIds={setActiveInfoIds}
        setShowInfo={setShowInfo}
      />
    </div>
  );
};

export default Project;
